module.exports = __webpack_public_path__ + "static/img/video-popup-bg-2-1.7128ffd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video-popup-bg-2-1.jpg
// module id = CR7K
// module chunks = 0